/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataRestoreNavigator.tpl.html';

angular
  .module('batch.metadataRestore.navigator', [])
  /**
   * Controller for the metadatarestore.navigator template.
   */
  .controller(
    'MetadataRestoreNavigatorCtrl',
    function ($scope, $filter, $rootScope, batchUtils, pagingUtils, BATCH_RESULTS, METADATA_RESTORE_BATCH_RESULT_TABS) {
      $scope.resultTabs = METADATA_RESTORE_BATCH_RESULT_TABS;

      $scope.batchHasErrors =
        batchUtils.currentBatch &&
        batchUtils.currentBatch.metadataRestoreData &&
        batchUtils.currentBatch.metadataRestoreData.objectsComplete !==
          batchUtils.currentBatch.metadataRestoreData.totalObjects;

      $scope.showSuccess =
        batchUtils.currentBatch &&
        batchUtils.currentBatch.metadataRestoreData &&
        batchUtils.currentBatch.metadataRestoreData.objectsComplete > 0;

      $scope.$parent.currentTab = $scope.batchHasErrors ? $scope.resultTabs.ERRORS : $scope.resultTabs.SUCCESS;

      $scope.pagingParam = pagingUtils.pagingInfo.metadataRestoreDetails;

      /**
       * Function to determine if item is selected.
       * @returns {Boolean} - Flag if the item is selected or not.
       */
      $scope.isSelected = function (tab) {
        return $scope.$parent.currentTab === tab;
      };

      /**
       * Function to show the correct content for the selected tab.
       */
      $scope.showTab = function (tab) {
        $scope.$parent.currentTab = tab;
      };

      $scope.setPage = function (page) {
        $scope.pagingParam.currentPage = page;
      };
    }
  );
